import { Alert, AlertTitle, Box, Button, Tooltip } from "@mui/material";
import { FC, useState } from "react";
import { selectLensEditorFormFields } from "redux/slices/lensEditor";
import { P } from "theme/typography";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import DoneIcon from "@mui/icons-material/Done";
import useCopy from "helpers/hooks/useCopy";
import { ValueGroupValidationError } from "generated/graphql";
import { useAppSelector } from "redux/hooks";

// Issue Card Component (child of ProfileIssuesModal)

type ICProps = {
  issue: ValueGroupValidationError;
};

const IssueCard: FC<ICProps> = ({ issue }) => {
  const [isCopied, copy] = useCopy();
  const [dropDownOpen, setDropDownOpen] = useState<boolean>(false);

  const fieldsSelector = useAppSelector(selectLensEditorFormFields);

  const field = fieldsSelector.find((field) => field.id === issue.fieldId);

  const toggleDropDown = () => {
    setDropDownOpen(!dropDownOpen);
  };

  return (
    <Alert
      onClick={toggleDropDown}
      severity="error"
      sx={{
        cursor: "pointer",
      }}
      action={
        <Tooltip title={isCopied ? "Copied!" : "Copy Issue to Clipboard"}>
          <Button
            color="inherit"
            onClick={() => {
              copy(JSON.stringify(issue, null, 2));
            }}>
            {isCopied ? <DoneIcon /> : <ContentCopyIcon />}
          </Button>
        </Tooltip>
      }>
      <Box
        sx={{
          cursor: "text",
        }}>
        <AlertTitle>
          {field?.name && field.name} ({issue.fieldId && issue.fieldId})
        </AlertTitle>

        <P
          variant="body2"
          sx={{
            fontFamily: "monospace",
          }}>
          {issue.issue}
        </P>

        {dropDownOpen && (
          <Box
            sx={{
              backgroundColor: "background.paper",
              borderRadius: 1,
              p: 1,
              mt: 1,
              fontFamily: "monospace",
            }}>
            {Object.keys(issue).map((key) => (
              <P key={key} variant="body2">
                {key}: {issue[key as keyof ValueGroupValidationError]}
              </P>
            ))}
          </Box>
        )}
      </Box>
    </Alert>
  );
};

export default IssueCard;
